import { prefixLanguage } from '@sub/src/utils/urls'
import { BASE_URL } from '@/router/consts'

const p = (postfix: string) => prefixLanguage(`${BASE_URL}${postfix}/`)

export const ORDERING_VOLUMES = p(':id/ordering')
